{
  "enum": {
    "ExcDtcFilesV1FileRequestStatus": {
      "ERRORED": "Errored",
      "FULFILLED": "Fulfilled",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcDtcFilesV1FileStatus": {
      "ERRORED": "Errored",
      "EXPECTED": "Expected",
      "INVALID": "Invalid",
      "UNSPECIFIED": "Unspecified",
      "VALIDATED": "Validated"
    }
  },
  "filterEnum": {
    "ExcDtcFilesV1FileQueryServiceFileListFilterableFields": {
      "fileId": "File ID",
      "status": "Status"
    },
    "ExcDtcFilesV1FileRequestQueryServiceFileRequestListFilterableFields": {
      "fileRequestId": "File Request ID",
      "status": "Status"
    }
  },
  "oneOf": {
    "ExcDtcFilesV1FileEventType": {
      "created": "Created",
      "errored": "Errored",
      "validationFailed": "Validation Failed",
      "validationPassed": "Validation Passed"
    },
    "ExcDtcFilesV1FileRequestEventType": {
      "created": "Created",
      "errored": "Errored",
      "fulfilled": "Fulfilled",
      "polled": "Polled"
    }
  },
  "sortEnum": {
    "ExcDtcFilesV1FileQueryServiceFileListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcDtcFilesV1FileRequestQueryServiceFileRequestListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}